module.exports = __webpack_public_path__ + "img/referal.573f5ddd.svg";